import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, doc, setDoc } from "firebase/firestore";

function añadir_total_gastos(gastos_total,costo) {
  console.log(gastos_total)
  console.log(costo);
  const db = getFirestore(firebaseApp);
  const collectionRef = collection(db, "Gastos".replace(/ /g, ""));
  const docRef = doc(collectionRef,"Gastos indirectos de producción empaque");
  setDoc(docRef, costo);
}

export default añadir_total_gastos;
